import type { ApiUserSavedSearchResponse } from "@/modules/jobAds/client/api/types"

import { keysToCamelCase } from "@/modules/apiRequests/dataStructure"
import { getResultFromResponse } from "@/modules/apiRequests/handlers"
import { handleFetchError } from "@/modules/fetch/errorHandler"
import { fetcher } from "@/modules/fetch/fetcher"

import { ADD_USER_MONO_SAVED_SEARCH_ENDPOINT } from "./constants"

type CreateUserSavedSearchRequest = {
  attributes: string
}

export const createUserSavedSearch = async ({
  attributes,
}: CreateUserSavedSearchRequest): Promise<ApiUserSavedSearchResponse> =>
  fetcher(ADD_USER_MONO_SAVED_SEARCH_ENDPOINT, {
    requestInit: {
      body: JSON.stringify({ attributes, type: "saved_search" }),
      method: "POST",
    },
    serviceDomain: "KRAKEND_API",
  })
    .then(
      getResultFromResponse<ApiUserSavedSearchResponse>({
        transformResult: keysToCamelCase<ApiUserSavedSearchResponse>,
      })
    )
    .catch(handleFetchError(ADD_USER_MONO_SAVED_SEARCH_ENDPOINT, { attributes }))
